<br><br><br><br>
<div class="page-title">
  <h1 class="title-text">JSA Submission</h1>
  <p class="form-desc">This form must be filled out prior to the start of each new job & every day for each crew on location.
    This must also be re-visited and readdressed if conditions change in the scope of work or environment.
  If utilising a pre-written JSA for the day, every step must be reviewed verbally and site specific information must be added to the JSA.</p>
</div>
<br>

  <mat-card class="mat-mdc-elevation-specific mat-elevation-z8">
    <mat-card-content>
      @if (checkingDraft) {
        <div class="custom-spinner-container">
          <div class="custom-spinner"></div>
        </div>
      } @else if (draftGateOpen) {
        <div class="stale-draft-gate">
          <h2 class="section-title">You have a saved JSA draft</h2>
          <p class="note">
            You saved a JSA draft earlier that hasn't been submitted yet. Click OK to load it
            and pick up where you left off.
          </p>
          <div class="gate-actions">
            <button mat-raised-button color="primary" type="button" (click)="loadSavedDraft()">
              OK
            </button>
          </div>
        </div>
      } @else {
      <form [formGroup]="form" appSubmitDiag="jsa" (ngSubmit)="create()">
        <br>
          <mat-form-field appearance="fill">
            <mat-label>Email:</mat-label>
            <input matInput placeholder="Enter email" formControlName="email" required>
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Office Reporting To:</mat-label>
            <mat-select formControlName="office" required>
              <mat-option value="houston">Houston</mat-option>
              <mat-option value="ftworth">Ft. Worth</mat-option>
              <mat-option value="austin">Austin</mat-option>
              <mat-option value="irving">Irving</mat-option>
              <mat-option value="frisco">Frisco</mat-option>
              <mat-option value="bossiercity">Bossier City</mat-option>
              <mat-option value="magnolia">Magnolia</mat-option>
              <mat-option value="windsor">Windsor</mat-option>
              <mat-option value="midland">Midland</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Client Name:</mat-label>
            <input matInput placeholder="Enter client name" formControlName="clientName" required>
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Project Number:</mat-label>
            <input matInput placeholder="Enter project number" formControlName="projectNumber" required>
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Project Name:</mat-label>
            <input matInput placeholder="Enter project name" formControlName="projectName" required>
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Date:</mat-label>
            <input matInput [matDatepicker]="datePicker" formControlName="userDate" required>
            <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
            <mat-datepicker #datePicker/>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Time:</mat-label>
            <input matInput [matTimepicker]="timePicker" formControlName="userTime" required>
            <mat-timepicker-toggle matIconSuffix [for]="timePicker"/>
            <mat-timepicker #timePicker/>
          </mat-form-field>


          <mat-form-field appearance="fill">
            <mat-label>Description of Work:</mat-label>
            <textarea matInput placeholder="Describe the work" formControlName="desc"></textarea>
          </mat-form-field>

          <mat-label class="qTitle">Select all equipment you will use for this job: *</mat-label>
          <br /><br />
          @if (form.get('equipmentUsed')?.invalid && form.get('equipmentUsed')?.touched) {
            <div class="error-message">
              (Check at least one box.)
            </div>
          }
          <br>
            <div formArrayName="equipmentUsed" class="checkbox-group">
              @for (equipment of equipmentUsed; track equipment; let i = $index) {
                <div>
                  <mat-checkbox [formControlName]="i">{{ formatEquipmentLabel(equipment) }}</mat-checkbox>
                </div>
              }
              <mat-checkbox [formControlName]="equipmentUsed.length">None of the Above</mat-checkbox>
            </div>
            <br><br>

            <mat-label class="qTitle">Potential Hazards:</mat-label>
            <br><br>
            <div formGroupName="hazards" class="checkbox-group">
              <mat-checkbox formControlName="drivingTravel">Driving/Travel</mat-checkbox>
              <mat-checkbox formControlName="confinedSpaces">Confined Spaces</mat-checkbox>
              <mat-checkbox formControlName="waterHazard">Water Hazard</mat-checkbox>
              <mat-checkbox formControlName="sharpEdges">Sharp Edges or hot/cold surfaces</mat-checkbox>
              <mat-checkbox formControlName="heatColdExposure">Heat/Cold Exposure</mat-checkbox>
              <mat-checkbox formControlName="liftingHazards">Lifting Hazards</mat-checkbox>
              <mat-checkbox formControlName="fireExplosionHazard">Fire/Explosion Hazard</mat-checkbox>
              <mat-checkbox formControlName="pinchCrushHazards">Pinch, Crush, or Striking Hazards</mat-checkbox>
              <mat-checkbox formControlName="electricalShock">Electrical Shock</mat-checkbox>
              <mat-checkbox formControlName="loneWorkers">Lone Workers</mat-checkbox>
              <mat-checkbox formControlName="excavationHazard">Excavation Hazard</mat-checkbox>
              <mat-checkbox formControlName="hazardousChemicalExposure">Hazardous Chemical Exposure</mat-checkbox>
              <mat-checkbox formControlName="roughTerrain">Rough Terrain</mat-checkbox>
              <mat-checkbox formControlName="potentialEnergyRelease">Potential Energy Release</mat-checkbox>
              <mat-checkbox formControlName="highNoiseLevels">High Noise Levels</mat-checkbox>
              <mat-checkbox formControlName="wildlifeContact">Wildlife/Livestock/Hunter Contact</mat-checkbox>
              <mat-checkbox formControlName="movingEquipment">Moving Equipment</mat-checkbox>
              <mat-checkbox formControlName="fallPotential">Fall Potential</mat-checkbox>
              <mat-checkbox formControlName="suspendedLoads">Suspended Loads</mat-checkbox>
              <mat-checkbox formControlName="poisonousPlants">Poisonous Plants</mat-checkbox>
              <mat-checkbox formControlName="other">Other...</mat-checkbox>
            </div>
            @if (form.get('hazards.other').value) {
              <div>
                <mat-form-field appearance="fill">
                  <mat-label>Specify Other</mat-label>
                  <input matInput placeholder="Enter other potential hazards" formControlName="otherHazardText">
                </mat-form-field>
              </div>
            }

            <hr><br>

            <mat-label class="qTitle">Emergency Contact Information</mat-label>
            <br><br><br>
            <mat-form-field appearance="fill">
              <mat-label>Nearest Hospital Name:</mat-label>
              <input matInput placeholder="Enter nearest hospital name" formControlName="hospitalName" required>
            </mat-form-field>

            <mat-form-field appearance="fill">
              <mat-label>Nearest Hospital Address:</mat-label>
              <input matInput placeholder="Enter nearest hospital address" formControlName="hospitalAddress" required>
            </mat-form-field>

            <mat-form-field appearance="fill">
              <mat-label>Nearest Hospital Telephone:</mat-label>
              <input matInput type="tel" placeholder="Enter nearest hospital telephone" formControlName="hospitalTele" required>
            </mat-form-field>

            <mat-form-field appearance="fill">
              <mat-label>Nearest Urgent Care Name:</mat-label>
              <input matInput placeholder="Enter nearest urgent care name" formControlName="ucName" required>
            </mat-form-field>

            <mat-form-field appearance="fill">
              <mat-label>Nearest Urgent Care Address:</mat-label>
              <input matInput placeholder="Enter nearest urgent care address" formControlName="ucAddress" required>
            </mat-form-field>

            <mat-form-field appearance="fill">
              <mat-label>Nearest Urgent Care Telephone:</mat-label>
              <input matInput type="tel" placeholder="Enter nearest urgent care telephone" formControlName="ucTele" required>
            </mat-form-field>

            <hr><br><br>

            <mat-label class="qTitle">Applicable Safe Work Practices:</mat-label>
            <br><br>
            <div formGroupName="safeWork" class="checkbox-group">
              <mat-checkbox formControlName="confinedSpacePermits">Confined Space Permits</mat-checkbox>
              <mat-checkbox formControlName="hotWorkPermits">Hot Work Permits</mat-checkbox>
              <mat-checkbox formControlName="lockoutTagoutPermits">Lockout/Tagout Permits</mat-checkbox>
              <mat-checkbox formControlName="fireExtinguisherUse">Fire Extinguisher Use</mat-checkbox>
              <mat-checkbox formControlName="barricadeFenceUse">Barricade/Fence Use</mat-checkbox>
              <mat-checkbox formControlName="specializedPPERequired">Specialized PPE Required</mat-checkbox>
              <mat-checkbox formControlName="specialPreJobSafetyTalks">Special Pre-Job Safety Talks</mat-checkbox>
              <mat-checkbox formControlName="simultaneousOperations">Simultaneous Operations</mat-checkbox>
              <mat-checkbox formControlName="emergencyActionPlanReview">Emergency Action Plan Review</mat-checkbox>
              <mat-checkbox formControlName="trafficControlPlan">Traffic Control Plan</mat-checkbox>
              <mat-checkbox formControlName="other">Other...</mat-checkbox>
            </div>
            @if (form.get('safeWork.other').value) {
              <div>
                <mat-form-field appearance="fill">
                  <mat-label>Specify Other</mat-label>
                  <input matInput placeholder="Enter other work practices" formControlName="otherWorkText">
                </mat-form-field>
              </div>
            }

            <br>

              <mat-label class="qTitle">Personal Protective Equipment Assessment:</mat-label>
              <br><br>
              <div formGroupName="personalEquip" class="checkbox-group">
                <mat-checkbox formControlName="hardHat">Hard Hat</mat-checkbox>
                <mat-checkbox formControlName="safetyGlassesGoggles">Safety Glasses/Goggles</mat-checkbox>
                <mat-checkbox formControlName="hiVisibilityVest">Hi-Visibility Vest</mat-checkbox>
                <mat-checkbox formControlName="taskSpecificGloves">Task Specific Gloves</mat-checkbox>
                <mat-checkbox formControlName="hearingProtection">Hearing Protection</mat-checkbox>
                <mat-checkbox formControlName="steelToeBoots">Steel Toe Boots</mat-checkbox>
                <mat-checkbox formControlName="fireRetardantClothing">Fire Retardant Clothing</mat-checkbox>
                <mat-checkbox formControlName="faceShields">Face Shields</mat-checkbox>
                <mat-checkbox formControlName="dustMaskRespirator">Dust Mask/Respirator</mat-checkbox>
                <mat-checkbox formControlName="snakeChaps">Snake Chaps</mat-checkbox>
                <mat-checkbox formControlName="rainGear">Rain Gear</mat-checkbox>
                <mat-checkbox formControlName="chainsawChaps">Chainsaw Chaps</mat-checkbox>
                <mat-checkbox formControlName="personalFlotationDevice">Personal Flotation Device</mat-checkbox>
                <mat-checkbox formControlName="dotApprovedHelmet">DOT Approved Helmet</mat-checkbox>
                <mat-checkbox formControlName="other">Other...</mat-checkbox>
              </div>
              @if (form.get('personalEquip.other').value) {
                <div>
                  <mat-form-field appearance="fill">
                    <mat-label>Specify Other</mat-label>
                    <input matInput placeholder="Enter other equipment" formControlName="otherEquipText">
                  </mat-form-field>
                </div>
              }

              <br>

                <mat-label class="qTitle">Potential Environmental Impacts:</mat-label>
                <br><br>
                <div formGroupName="enviroImpact" class="checkbox-group">
                  <mat-checkbox formControlName="hazWasteDisposal">Haz Waste Disposal</mat-checkbox>
                  <mat-checkbox formControlName="arcSiteImpact">Arc Site Impact</mat-checkbox>
                  <mat-checkbox formControlName="wetlandContamination">Wetland Contamination</mat-checkbox>
                  <mat-checkbox formControlName="stormwaterPollution">Stormwater Pollution</mat-checkbox>
                  <mat-checkbox formControlName="endangerWildlife">Endanger Wildlife</mat-checkbox>
                  <mat-checkbox formControlName="releaseOfGas">Release of Gas/Liquids/Solids/Dust</mat-checkbox>
                  <mat-checkbox formControlName="other">Other...</mat-checkbox>
                </div>
                @if (form.get('enviroImpact.other').value) {
                  <div>
                    <mat-form-field appearance="fill">
                      <mat-label>Specify Other</mat-label>
                      <input matInput placeholder="Enter other environmental impacts" formControlName="otherEnvText">
                    </mat-form-field>
                  </div>
                }

                <br><hr><br>

                <div class="safety-reminders">
                  <mat-label class="qTitle">Safety Reminders</mat-label>
                  <ul>
                    <li>Each job or operation consists of a set of tasks/steps. Be sure to list all the MAJOR job steps needed to perform the job.</li>
                    <li>
                      A hazard is a potential danger. Break hazards into five steps:
                      <ul>
                        <li>Contact - victim is struck by or strikes an object.</li>
                        <li>Caught - victim is caught on, caught in or caught between objects.</li>
                        <li>Fall - victim falls to ground or lower level (includes slips and trips).</li>
                        <li>Exertion - excessive strain or stress/ergonomics/lifting techniques.</li>
                        <li>Exposure - skin contact/inhalation hazards.</li>
                      </ul>
                    </li>
                    <li>An environmental impact is a potential for damage to the natural environment (i.e. spills of chemicals, fuel, or other contaminated material).</li>
                    <li>Using the first two columns as a guide, describe what actions or procedures are necessary to eliminate or minimise the risk.</li>
                    <li>List the recommended safe operating procedures, indicating exactly what needs to be done - such as "use two persons to lift", avoid making general statements such as "be careful".</li>
                  </ul>
                </div>
                <p class="note">
                  For each Major Job Step entered below, the corresponding Potential Hazards and Actions Taken to Eliminate Hazard fields will appear sequentially. Please complete each section in order to proceed.
                </p>

                <mat-form-field appearance="fill">
                  <mat-label>1. Major Job Steps:</mat-label>
                  <input matInput placeholder="Enter major job steps" formControlName="stepOne" name="stepOne" (ngModelChange)="onJobStepChange(1)">
                </mat-form-field>

                @if (form.controls['stepOne'].value) {
                  <div>
                    <mat-form-field appearance="fill">
                      <mat-label>1. Potential Hazards & Consequences:</mat-label>
                      <input matInput placeholder="Enter potential hazards" formControlName="hazardOne" name="hazardOne" (ngModelChange)="onHazardChange(1)">
                    </mat-form-field>
                  </div>
                }

                @if (form.controls['hazardOne'].value) {
                  <div>
                    <mat-form-field appearance="fill">
                      <mat-label>1. Actions Taken To Eliminate Hazard:</mat-label>
                      <input matInput placeholder="Enter actions taken" formControlName="actionOne" name="actionOne">
                    </mat-form-field>
                  </div>
                }

                <mat-form-field appearance="fill">
                  <mat-label>2. Major Job Steps:</mat-label>
                  <input matInput placeholder="Enter major job steps" formControlName="stepTwo" name="stepTwo" (ngModelChange)="onJobStepChange(2)">
                </mat-form-field>

                @if (form.controls['stepTwo'].value) {
                  <div>
                    <mat-form-field appearance="fill">
                      <mat-label>2. Potential Hazards & Consequences:</mat-label>
                      <input matInput placeholder="Enter potential hazards" formControlName="hazardTwo" name="hazardTwo" (ngModelChange)="onHazardChange(2)">
                    </mat-form-field>
                  </div>
                }

                @if (form.controls['hazardTwo'].value) {
                  <div>
                    <mat-form-field appearance="fill">
                      <mat-label>2. Actions Taken To Eliminate Hazard:</mat-label>
                      <input matInput placeholder="Enter actions taken" formControlName="actionTwo" name="actionTwo">
                    </mat-form-field>
                  </div>
                }

                <mat-form-field appearance="fill">
                  <mat-label>3. Major Job Steps:</mat-label>
                  <input matInput placeholder="Enter major job steps" formControlName="stepThree" name="stepThree" (ngModelChange)="onJobStepChange(3)">
                </mat-form-field>

                @if (form.controls['stepThree'].value) {
                  <div>
                    <mat-form-field appearance="fill">
                      <mat-label>3. Potential Hazards & Consequences:</mat-label>
                      <input matInput placeholder="Enter potential hazards" formControlName="hazardThree" name="hazardThree" (ngModelChange)="onHazardChange(3)">
                    </mat-form-field>
                  </div>
                }

                @if (form.controls['hazardThree'].value) {
                  <div>
                    <mat-form-field appearance="fill">
                      <mat-label>3. Actions Taken To Eliminate Hazard:</mat-label>
                      <input matInput placeholder="Enter actions taken" formControlName="actionThree" name="actionThree">
                    </mat-form-field>
                  </div>
                }

                <mat-form-field appearance="fill">
                  <mat-label>4. Major Job Steps:</mat-label>
                  <input matInput placeholder="Enter major job steps" formControlName="stepFour" name="stepFour" (ngModelChange)="onJobStepChange(4)">
                </mat-form-field>

                @if (form.controls['stepFour'].value) {
                  <div>
                    <mat-form-field appearance="fill">
                      <mat-label>4. Potential Hazards & Consequences:</mat-label>
                      <input matInput placeholder="Enter potential hazards" formControlName="hazardFour" name="hazardFour" (ngModelChange)="onHazardChange(4)">
                    </mat-form-field>
                  </div>
                }

                @if (form.controls['hazardFour'].value) {
                  <div>
                    <mat-form-field appearance="fill">
                      <mat-label>4. Actions Taken To Eliminate Hazard:</mat-label>
                      <input matInput placeholder="Enter actions taken" formControlName="actionFour" name="actionFour">
                    </mat-form-field>
                  </div>
                }

                <mat-form-field appearance="fill">
                  <mat-label>5. Major Job Steps:</mat-label>
                  <input matInput placeholder="Enter major job steps" formControlName="stepFive" name="stepFive" (ngModelChange)="onJobStepChange(5)">
                </mat-form-field>

                @if (form.controls['stepFive'].value) {
                  <div>
                    <mat-form-field appearance="fill">
                      <mat-label>5. Potential Hazards & Consequences:</mat-label>
                      <input matInput placeholder="Enter potential hazards" formControlName="hazardFive" name="hazardFive" (ngModelChange)="onHazardChange(5)">
                    </mat-form-field>
                  </div>
                }

                @if (form.controls['hazardFive'].value) {
                  <div>
                    <mat-form-field appearance="fill">
                      <mat-label>5. Actions Taken To Eliminate Hazard:</mat-label>
                      <input matInput placeholder="Enter actions taken" formControlName="actionFive" name="actionFive">
                    </mat-form-field>
                  </div>
                }



                <br><hr><br><br>

                <mat-label class="qTitle">Does everyone involved in the project understand the job hazards, processes, and safe work practices? *</mat-label>
                <br><br>
                @if (form.get('ynOne')?.invalid && form.get('ynOne')?.touched) {
                  <div class="error-message">(Please select an answer.)</div>
                  <br>
                }
                <mat-radio-group formControlName="ynOne" name="ynOne">
                  <mat-radio-button value="yes">Yes</mat-radio-button>
                  <mat-radio-button value="no">No</mat-radio-button>
                  <mat-radio-button value="na">N/A</mat-radio-button>
                </mat-radio-group>
                <br><br>

                <mat-label class="qTitle">Are all applicable permits in place (Lockout/Tagout, Excavation, Confined Space)? *</mat-label>
                <br><br>
                @if (form.get('ynTwo')?.invalid && form.get('ynTwo')?.touched) {
                  <div class="error-message">(Please select an answer.)</div>
                  <br>
                }
                <mat-radio-group formControlName="ynTwo" name="ynTwo">
                  <mat-radio-button value="yes">Yes</mat-radio-button>
                  <mat-radio-button value="no">No</mat-radio-button>
                  <mat-radio-button value="na">N/A</mat-radio-button>
                </mat-radio-group>
                <br><br>

                <mat-label class="qTitle">Are all workers trained in the specific job tasks they will be performing? *</mat-label>
                <br><br>
                @if (form.get('ynThree')?.invalid && form.get('ynThree')?.touched) {
                  <div class="error-message">(Please select an answer.)</div>
                  <br>
                }
                <mat-radio-group formControlName="ynThree" name="ynThree">
                  <mat-radio-button value="yes">Yes</mat-radio-button>
                  <mat-radio-button value="no">No</mat-radio-button>
                  <mat-radio-button value="na">N/A</mat-radio-button>
                </mat-radio-group>
                <br><br>

                <mat-label class="qTitle">Are First Aid Kits and Fire Extinguishers inspected & readily available? *</mat-label>
                <br><br>
                @if (form.get('ynFour')?.invalid && form.get('ynFour')?.touched) {
                  <div class="error-message">(Please select an answer.)</div>
                  <br>
                }
                <mat-radio-group formControlName="ynFour" name="ynFour">
                  <mat-radio-button value="yes">Yes</mat-radio-button>
                  <mat-radio-button value="no">No</mat-radio-button>
                  <mat-radio-button value="na">N/A</mat-radio-button>
                </mat-radio-group>
                <br><br>

                <mat-label class="qTitle">Does everyone involved in the project understand the job's "Emergency Evacuation Plan"? *</mat-label>
                <br><br>
                @if (form.get('ynFive')?.invalid && form.get('ynFive')?.touched) {
                  <div class="error-message">(Please select an answer.)</div>
                  <br>
                }
                <mat-radio-group formControlName="ynFive" name="ynFive">
                  <mat-radio-button value="yes">Yes</mat-radio-button>
                  <mat-radio-button value="no">No</mat-radio-button>
                  <mat-radio-button value="na">N/A</mat-radio-button>
                </mat-radio-group>
                <br><br><hr><br><br>

                <mat-label class="qTitle">Job Safety Analysis (JSA) Participants Signature</mat-label><br><br>
                <mat-label class="note">By inputting your name below, you are verifying that the statements and information provided are true and correct, and you are attesting to the validity of all contents within this electronic submission. By clicking on the submit button, you are deemed to have electronically signed this statement.</mat-label>
                <br><br>
                <mat-form-field appearance="fill">
                  <mat-label>Signature</mat-label>
                  <input matInput placeholder="Please Sign" formControlName="signature1" required>
                </mat-form-field>
                <br>
                  <mat-label class="note">Please click below for additional signatures:</mat-label>
                  <button mat-button type="button" (click)="showAdditionalSignatures = !showAdditionalSignatures">
                    {{ showAdditionalSignatures ? 'Hide Additional Signatures' : 'Add More Signatures' }}
                  </button>

                  @if (showAdditionalSignatures) {
                    <div>
                      <mat-form-field appearance="fill">
                        <mat-label>Additional Signature 2</mat-label>
                        <input matInput placeholder="Please Sign" formControlName="signature2">
                      </mat-form-field>
                      <mat-form-field appearance="fill">
                        <mat-label>Additional Signature 3</mat-label>
                        <input matInput placeholder="Please Sign" formControlName="signature3">
                      </mat-form-field>
                      <mat-form-field appearance="fill">
                        <mat-label>Additional Signature 4</mat-label>
                        <input matInput placeholder="Please Sign" formControlName="signature4">
                      </mat-form-field>
                      <mat-form-field appearance="fill">
                        <mat-label>Additional Signature 5</mat-label>
                        <input matInput placeholder="Please Sign" formControlName="signature5">
                      </mat-form-field>
                    </div>
                  }
                  <div class="button-container">
                    @if (autosaveStatus) {
                      <span class="note draft-message">{{ autosaveStatus }}</span>
                    }
                    <button mat-raised-button color="primary" class="submit-button" [disabled]="isSubmitting">{{ isSubmitting ? 'Submitting…' : 'Submit' }}</button>
                  </div>
                  <app-connection-monitor></app-connection-monitor>

                  @if (isSubmitting) {
                    <div class="custom-spinner-container">
                      <div class="custom-spinner"></div>
                    </div>
                  }

                  @if (!isSubmitting && form.invalid && form.touched) {
                    <div class="error-message">
                      Please fill in all required fields.
                    </div>
                  }

                  @if (warningMessage) {
                    <div class="error-message">{{ warningMessage }}</div>
                  }

                </form>
              }
              </mat-card-content>
            </mat-card>
            <br><br>

            <div class="page-title">
              <p class="form-desc-two">Please email <i class="contact">support&#64;landpoint.net</i> to report JSA form submission problems.</p>
            </div>
